<template>
  <div class="invoice-container" id="vendors-block">
    <filters-actions
      @search="handleSearch"
      @filter="handleFilter"
      @changeCheckbox="isActiveChange"
      @add="$router.push({ name: 'system-admin-vendor-add' })"
      :search="{ placeholder: 'vendor' }"
      :filter="{ options: this.types }"
      :addButtton="{ text: 'Add Vendor' }"
    />
    <!-- <div class="show-active-items">
      <input type="checkbox" id="show-active" class="active-checkbox" v-model="isActive" />
      <label for="show-active">Active Only</label>
    </div>-->
    <loader :loading="loading" v-if="loading" />
    <template v-else>
      <not-found v-if="isFound" />
      <div
        v-else
        class="table_div"
        style="width: 100%; overflow-x: auto; overflow-y: hidden"
      >
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th>Vendor Name</th>
<!--              <th>Contact Name</th>-->
<!--              <th>Contact Person</th>-->
              <th>
                Created On
                <span v-on:click="sorting('up', 'created_on')" class="sorting"
                >&#8593;</span
                >
                <span v-on:click="sorting('down', 'created_on')" class="sorting"
                >&#8595;</span
                >
              </th>
              <th>
                Last Updated
                <span v-on:click="sorting('up', 'updated_on')" class="sorting"
                >&#8593;</span
                >
                <span v-on:click="sorting('down', 'updated_on')" class="sorting"
                >&#8595;</span
                >
              </th>
              <th>Updated By</th>
              <th>Action</th>
              <!-- <th></th>
              <th></th>-->
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              class="line"
              v-for="(vendor, k) in vendors"
              :key="k"
              :class="{
                active: vendor.status === 'active',
                inactive: vendor.status === 'inactive',
              }"
            >
              <th>
                <div class="img-container d-flex">
                  <div @click="changeStatus(vendor)" class="status"></div>
                  <!-- <img
                    v-if="vendor.logo_file"
                    class="popup_image"
                    :src="`http://88.198.219.62/api_smsc/v1/file/${vendor.logo_file}`"
                    alt
                  />
                  <img v-else class="popup_image" />-->
                  <span
                    class="name-span d-flex mx-auto"
                    @copy="copyFullName"
                    :title="vendor.contactName"
                    >{{ vendor.vendorName }}</span
                  >
<!--                  {{ vendor.vendorName | snippet }}-->
                </div>
              </th>
<!--              <th @copy="copyFullName" :title="vendor.contactName">-->
<!--                {{ vendor.contactName | snippet }}-->
<!--              </th>-->
<!--              <th class="break">{{ vendor.contactPerson }}</th>-->
              <!-- <th
                @copy="copyFullName"
                :title="vendor.nocEmail"
                class="break"
              >{{vendor.nocEmail | snippet}}</th>-->
              <th class="break">{{ vendor.createdOn }}</th>
              <th class="break">{{ vendor.updatedOn }}</th>
              <th class="break">{{ vendor.updatedBy }}</th>
              <th class="icon-right">
                <div>
                  <svg
                    @click="
                      $router.push({
                        name: 'system-admin-vendor-accounts-list',
                        params: {
                          vendor_uuid: vendor.vendorId || null,
                          vendor_name: vendor.vendorName,
                        },
                      })
                    "
                    class="svg-grey accounts"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <title>SMSC Bind</title>
                    <path
                      d="M19.3070588,15.3745636 L18.5167157,15.3745636 C20.0434804,14.3694763 21.0561275,12.6217456 21.0561275,10.6378055 C21.0561275,7.52907731 18.5704412,5 15.515049,5 C12.4596569,5 9.97397059,7.52907731 9.97397059,10.6378055 C9.97397059,12.6217456 10.9865196,14.3694763 12.5133824,15.3745636 L11.7230392,15.3745636 C9.69196078,15.3745636 8.03955882,17.0557107 8.03955882,19.1222444 L8.03955882,24.3573067 C8.03955882,24.7016459 8.31392157,24.9807481 8.65230392,24.9807481 L22.3777941,24.9807481 C22.7161765,24.9807481 22.9905392,24.7016459 22.9905392,24.3573067 L22.9905392,19.1221945 C22.9905392,17.0557107 21.3381373,15.3745636 19.3070588,15.3745636 Z M11.1994608,10.6378055 C11.1994608,8.21665835 13.1353922,6.24688279 15.515049,6.24688279 C17.8946569,6.24688279 19.8306373,8.21665835 19.8306373,10.6378055 C19.8306373,13.0589027 17.8946569,15.0286284 15.515049,15.0286284 C13.1353922,15.0286284 11.1994608,13.0589027 11.1994608,10.6378055 Z M17.3078431,15.9724688 L15.515049,17.7966085 L13.7222549,15.9725187 C14.2848529,16.1687781 14.8878922,16.2755112 15.515049,16.2755112 C16.1422059,16.2755112 16.7452941,16.1687781 17.3078431,15.9724688 Z M21.765049,23.7338155 L20.0983824,23.7338155 L20.0983824,20.7383541 C20.0983824,20.394015 19.8240196,20.1149127 19.4856373,20.1149127 C19.1472549,20.1149127 18.8728922,20.394015 18.8728922,20.7383541 L18.8728922,23.7338155 L12.1572059,23.7338155 L12.1572059,20.7383541 C12.1572059,20.394015 11.8828431,20.1149127 11.5444608,20.1149127 C11.2060784,20.1149127 10.9317157,20.394015 10.9317157,20.7383541 L10.9317157,23.7338155 L9.26504902,23.7338155 L9.26504902,19.1221945 C9.26504902,17.7432918 10.3676961,16.6213965 11.7230392,16.6213965 L12.6269118,16.6213965 L15.0817647,19.1190524 C15.2014216,19.240798 15.3582353,19.3016459 15.515049,19.3016459 C15.6718627,19.3016459 15.8285784,19.240798 15.9483333,19.1190524 L18.4031863,16.6213965 L19.3070588,16.6213965 C20.6623529,16.6213965 21.765049,17.743192 21.765049,19.1221945 L21.765049,23.7338155 Z"
                      id="path-1"
                    />
                  </svg>
                  <span class="did-icon" title="DID">
                    <svg
                      @click="
                        $router.push({
                          name: 'system-admin-vendor-did',
                          params: {
                            id: vendor.vendorId,
                            vendor_name: vendor.vendorName,
                          },
                        })
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                    >
                      <path
                        fill="currentColor"
                        d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                      />
                    </svg>
                  </span>
                  <span class="edit-icon" title="Edit">
                  <svg
                    @click="
                      $router.push({
                        name: 'system-admin-vendor-edit',
                        params: { id: vendor.vendorId },
                      })
                    "
                    class="svg-grey"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    version="1.1"
                  >
                    <path
                      d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                      id="path-1"
                    />
                  </svg>
                  </span>
                  <span class="delete-icon" title="Delete">
                  <svg
                    @click="deleteVendor(vendor)"
                    class="svg-grey"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    version="1.1"
                  >
                    <path
                      d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                      id="path-1"
                    />
                  </svg>
                  </span>
                  <span class="rate-icon" title="Rate">
                  <svg
                    @click="
                      $router.push({
                        name: 'system-admin-vendor-rate-deck',
                        params: { id: vendor.vendorId },
                      })
                    "
                    class="svg-grey"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    version="1.1"
                  >
                    <path
                      d="M24.3333333,22.6234595 L7.1656,22.6234595 L9.95824,16.9509189 L12.8546667,18.8602162 C13.03872,18.9815676 13.2700267,19.0032973 13.47296,18.9181081 C13.6759467,18.8331351 13.8245333,18.6521622 13.8701867,18.4344865 L15.0018133,13.0466486 L18.1837867,14.6959459 C18.4528,14.8354595 18.78064,14.7740541 18.9827733,14.5463784 L21.6315733,11.5637297 L21.71488,12.467027 C21.7470933,12.8172432 22.0377067,13.0799459 22.37792,13.0799459 C22.3986667,13.0799459 22.4196267,13.078973 22.4406933,13.076973 C22.8073067,13.0422703 23.0766933,12.712973 23.0425067,12.3414054 L22.8059733,9.774 C22.7716267,9.40243243 22.4470933,9.12924324 22.0802133,9.16405405 L19.5470933,9.40367568 C19.1805333,9.43837838 18.91104,9.76767568 18.9452267,10.1391892 C18.9796267,10.5107568 19.3035733,10.7838919 19.67104,10.7491351 L20.6428267,10.6571892 L18.33472,13.2562703 L14.8345067,11.442 C14.6498667,11.3462162 14.43168,11.3431351 14.24448,11.4334595 C14.0571733,11.5237838 13.92208,11.6972973 13.87888,11.9029189 L12.7682667,17.1910811 L10.0589333,15.4051351 C9.89962667,15.3001081 9.70362667,15.2689189 9.52037333,15.3195676 C9.33701333,15.3701081 9.18368,15.4975135 9.09893333,15.6697838 L6.33333333,21.2874054 L6.33333333,6.70086486 C6.33333333,6.32767568 6.03482667,6.02518919 5.66666667,6.02518919 C5.29850667,6.02518919 5,6.32767568 5,6.70086486 L5,23.2991351 C5,23.6722703 5.29850667,23.9748108 5.66666667,23.9748108 L24.3333333,23.9748108 C24.70144,23.9748108 25,23.6722703 25,23.2991351 C25,22.926 24.70144,22.6234595 24.3333333,22.6234595 Z"
                      id="path-1"
                    />
                  </svg>
                  </span>
                </div>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex-wrap" :style="{ display: paginationCondition ? 'flex' : 'block' }">
        <div class="per-page ml-2">
          <span class="filter_by">Show Per Page:</span>
          <div class="primary-input-container choose-type perPage">
            <primary-select
              type="text"
              @input="changePerPage"
              v-model="per_page" :is-cross="false"
              class="choose-type perPage"
              placeholder="Select"
            >
              <option :value="item" v-for="(item, key) in pages" :key="key">
                {{ item }}
              </option>
            </primary-select>
          </div>
        </div>
        <div
          v-if="!isFound"
          class="buttons-wrapper"
          :class="{ pagination: paginationCondition }"
        >
          <pagination-component
            @change-page="changePage($event)"
            :page="Page"
            :total="TotalPages"
            :perPage="per_page"
            :qnt="vendors.length"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    DownloadAttachmentDropDown: () =>
      import("@/components/DropDowns/Billing/DownloadAttachmentDropDown.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    AppDropdown: () => import("@/components/DropDowns/Dropdown.vue"),
    //bDropdown: ()=> import('bootstrap-vue/es/components/dropdown/dropdown'),
    FiltersActions: () => import("@/components/FiltersAndActions.vue"),
    Loader: () => import("@/components/Loader.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    showDropDown: false,
    vendors: [],
    types: [
      { name: "ALL", value: "ALL" },
      { name: "MO", value: "MO" },
      { name: "MT", value: "MT" },
    ],
    pages: [10, 50, 100],
    per_page: 10,
    Total: null,
    TotalPages: null,
    Page: 0,
    Searched: "",
    type: "ALL",
    loading: true,
    isFound: false,
    isActive: false,
  }),
  filters: {
    snippet: function (v) {
      let length = v && v.length;
      if (length > 8) {
        return v.slice(0, 3) + "..." + v.slice(length - 5, length);
      } else {
        return v;
      }
    },
    formatDate(d) {
      const date = new Date(d);
      const year = date.getFullYear();
      const _month = String(date.getMonth() + 1);
      const month = _month.length === 1 ? `0${_month}` : _month;
      const _day = String(date.getDate());
      const day = _day.length === 1 ? `0${_day}` : _day;

      return `${year}/${month}/${day}`;
    },
  },
  computed: {
    paginationCondition() {
      return this.vendors.length < this.per_page && this.Page === 0;
    },
  },
  created() {
    this.GetList();
  },
  methods: {
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.order_dir = order_dir;
      this.order_by = sortBy;

      this.GetList(order_dir, sortBy);
    },
    isActiveChange(e) {
      this.isActive = e;
      this.Page = 0;
      this.GetList();
    },
    changePerPage(e) {
      this.Page = 0;
      this.GetList();
    },
    copyFullName(e) {
      const fullName = e.target.getAttribute("title");
      const input = document.createElement("input");
      input.value = fullName;
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    handleSearch(v) {
      this.Searched = v;
      this.Page = 0;
      this.GetList();
    },
    handleFilter(v) {
      this.type = v;
      this.Page = 0;
      this.GetList();
    },
    GetList(order_dir = "desc", order_by = "created_on") {
      this.loading = true;
      this.isFound = false;
      this.$store
        .dispatch("GetVendorList", {
          vendor_name: this.Searched,
          page: this.Page,
          vendor_type: this.type == "ALL" ? "" : this.type,
          per_page: this.per_page,
          is_active: this.isActive,
          order_by: order_by,
          order_dir: order_dir,
        })
        .then((res) => {
          console.log("Vendor List -> ", res);
          this.loading = false;
          if (!res.items.length) {
            this.isFound = true;
            return;
          }
          this.vendors = res.items.map(this.transformVendors);
          this.per_page = res.per_page;
          this.Total = res.total;
          this.TotalPages = res.total / res.per_page;
        });
    },
    transformVendors(i, k) {
      return {
        contactName: i.vendor_name,
        vendorName: i.vendor_name,
        // createdOn: i.created_on,
        createdOn: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
        // updatedOn: i.updated_on,
        updatedOn: format(i.updated_on, "YYYY:MM:DD HH:mm:ss"),
        updatedBy: i.updated_by,
        vendorId: i.vendor_uuid,
        type: i.vendor_type,
        contactPerson: i.contact_person,
        logo_file: i.logo_file_uuid,
        status: i.status,
      };
    },
    changeStatus(vendor) {
      this.$store
        .dispatch("EditVendor", {
          vendor: { is_active: vendor.status === "active" ? false : true },
          id: vendor.vendorId,
        })
        .then((res) => {
          this.$snotify.success("Vendor status was changed.", {
            timeout: 6000,
          });
          this.GetList();
        });
    },
    deleteVendor(vendor) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this vendor!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then(async (result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteVendor", vendor.vendorId)
            .then(() => {
              this.$swal({
                title: "Deleted!",
                text: "The Vendor has been deleted.",
                type: "success",
              });
              this.GetList();
            })
            .catch((err) => {
              this.$error(err);
            });
        }
      });
    },
  },
};
</script>

<style>
#vendors-block .add-navigation {
  align-items: flex-start;
}
#vendors-block .add-navigation .right-wrapper {
  align-items: flex-start;
}
#vendors-block .add-navigation .right-wrapper .show-active-items {
  padding: 8px 0;
}
</style>
<style lang="scss" scoped>
.add-navigation{
  margin-bottom: 0px!important;
}
.invoice-container {
  padding: 0px 20px 0px 20px;
  //padding: 0 20px;

  // .show-active-items {
  //   display: flex;
  //   align-items: center;
  //   // margin-left: 20px;
  //   padding: 15px 0;

  //   .active-checkbox {
  //     width: 20px;
  //     height: 20px;
  //     margin-right: 10px;
  //   }
  //   label {
  //     margin-bottom: 0;
  //   }
  // }
  .per-page {
    display: flex;
    //align-items: center;
    margin-top: 20px;

    .filter_by {
      margin-right: 15px;
      color: #55616e;
      font-weight: normal;
      font-family: "Helvetica Neue";
      font-size: 14px;
    }
    .perPage {
      width: 120px;
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    width: 100%;

    &.pagination {
      width: fit-content;
      flex-grow: 1;
    }
    .primary-button {
      height: 40px;
      width: 130px;
    }
  }
}
table.Invoice_table {
  width: 100%;
  margin-top: 20px;

  th {
    text-align: center;
    padding-left: 0;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead th:first-child {
  //  padding-left: 20px;
  //     padding-right: 30px;
  width: 14%;
}
table,
tr {
  width: 100%;
  height: 40px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}
table tr th {
  padding: 0px 0px 0 20px;
  margin-right: 10px;
}
th.button {
  padding: 7px 0;
}
table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  //padding: 10px 15px 10px 0;
  margin: 0 auto;
  padding-right: 15px;
  height: 100%;
  float: right;
  .svg-grey {
    fill: #55616e;
    margin-right: 15px;
  }
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 44px;
  font-size: 14px;
  line-height: 20px;
  padding: 15px 0px;
  text-align: left;
}
tbody th:first-child {
  display: flex;
  padding: 0;
  span {
    padding: 12px 0;
  }
}
tbody th.break {
  max-width: 100px;
  word-wrap: break-word;
  padding-right: 15px;
  line-height: 20px;
  color: #55616e;
  font-family: "Helvetica Neue";
}
tbody th .did {
  width: 50px;
  height: 24px;
  line-height: 19px;
  margin-right: 2px;
  padding: 0;
}
tbody th .account {
  width: 75px;
  height: 24px;
  line-height: 19px;
  margin-right: 2px;
  padding: 0;
}
tbody th.icon-right {
  width: 190px;
  padding: 7px 0;

  div {
    display: flex;
    justify-content: flex-end;

    .did-icon {
      position: relative;
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 4px;
      border-radius: 50%;
      background: #c0c6d1;

      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 58%;

        path {
          fill: #fff;
        }
      }
    }
  }
  .svg-grey {
    fill: #55616e;
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }
}

.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-grid;
  margin: 17px 12px 0 13px;
  cursor: pointer;
  float: left;
}

.active {
  th .status {
    background-color: #24e2b8;
  }
}
.inactive {
  background-color: #f0f1fa;
  th .status {
    background-color: #d2305b;
  }
}
.img-container {
  // display: flex;
  width: 100%;
  text-align: center;

  .name-span {
    padding: 0;
    line-height: 44px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
    margin-left: 38px;
  }
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin: 7px 8px 7px 0;
}
.primary {
  // padding-top: 11px;
  width: 90px !important;
  height: 30px !important;
  font-size: 12px !important;
  line-height: 20px !important;
  border-radius: 100px !important;
  margin-right: 10px !important;
}
.primary.active {
  border: 2px solid #ffffff;
  border-radius: 100px;
  background-color: #24e2b8;
  color: #ffffff;
  padding: 0;
  // opacity: 0.68;
}
@media (max-width: 1519px) {
  table.Invoice_table {
    width: 1500px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

